import { Button, Input, Select, Space } from "antd";
import styles from './EmployeesGraph.module.css';
import { useState } from "react";
import { CallStatusList } from "../../../utils/data";
import useAntSelectStyles from "../../../hooks/useAntSelectStyles";

export const SelectFormField = ({
  labelFor,
  labelText,
  value,
  onChange,
  options = [],
  labelStyles = {},
  inputStyles = {},
  disabled = false,
  filterOption,
  showSearch = false,
}) => {
  return (
    <div className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-between flex-column flex-lg-row align-items-stretch align-items-lg-center">
      <label htmlFor={labelFor} style={{ margin: 0, ...labelStyles }}>
        {labelText}
        <span>:</span>
      </label>
      <Select
        value={value}
        onChange={onChange}
        className={styles.inputStyles}
        id={labelFor}
        disabled={disabled}
        style={inputStyles}
        showSearch={showSearch}
        filterOption={filterOption}
        options={options.map((d) => ({
          label: d.text,
          value: d.value,
        }))}
      >
        {options.map((option) => {
          return (
            <Select.Option key={option.key} value={option.value}>
              {option.text}
            </Select.Option>
          );
        })}
      </Select>
    </div>
  );
};

export const InputFormField = ({
  labelFor,
  labelText,
  value,
  onChange,
  disabled = false,
  inputStyles = {},
  labelStyles = {},
}) => {
  return (
    <div className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-between flex-column flex-lg-row align-items-stretch align-items-lg-center">
      <label htmlFor={labelFor} style={{ margin: 0, ...labelStyles }}>
        {labelText}
        <span>:</span>
      </label>
      <Input
        value={value}
        onChange={onChange}
        id={labelFor}
        className={styles.inputStyles}
        disabled={disabled}
        style={inputStyles}
      />
    </div>
  );
};

export const FunnelForm = ({ filterDispatch, fetchFunnelQuarterData }) => {
  // useAntSelectStyles();
  const [formData, setFormData] = useState({
    callStatus: 0
  })
  const handleSubmit = (e) => {
    e.preventDefault();
    fetchFunnelQuarterData();
  }

  let allOptions = [
    {
      key: 0, 
      value: 0,
      text: "Select",
      label: "Select"
    },
    ...CallStatusList.map(callStatus => ({
      key: callStatus.id,
      value: callStatus.id,
      text: callStatus.value,
      label: callStatus.value
    }))
  ];

  return (
    <form onSubmit={handleSubmit}>
      <Space direction="horizontal" align="end" className={styles.funnelFormContainer} style={{
        width: '100%',
        marginBottom: "2rem"
      }}>
        
          <SelectFormField
            labelFor="callStatus"
            labelText="Call Status"
            value={formData.callStatus}
            onChange={(selectedCallStatus) => {
              setFormData((prev) => ({
                ...prev,
                callStatus: selectedCallStatus
              }));
              filterDispatch({ type: "CALL_STATUS", value: selectedCallStatus });
            }}
            options={allOptions}
            inputStyles={{
              minWidth: '230px'
            }}
            labelStyles={{
              minWidth: '100%',
              marginRight: '1rem',
            }}
          />
          <Button type="primary" htmlType="submit" style={{ borderRadius: '0px' }}>Filter</Button>
      </Space>
    </form>
  )
}